import { SwitchButton } from '@components/core-ui/form-elements/buttons/Button/variations/SwitchButton';
import { HeaderSwitchWrapper } from '@components/Header/components/HeaderSwitchWrapper';
import { BarElement, CategoryScale, Chart as ChartJS, LinearScale } from 'chart.js';
import { useMemo, useState } from 'react';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement);

type DataItem = {
  date: string;
  value: number;
};

type TProps = {
  data: {
    week?: DataItem[];
    month?: DataItem[];
  };
};

export const DailyActivity = ({ data }: TProps) => {
  const [period, setPeriod] = useState<'7days' | '30days'>('7days');

  const isDark = document.documentElement.dataset.theme === 'dark';
  const chartTheme = useMemo(() => {
    return {
      muted: isDark ? '#9aa7c1' : '#858dbd',
      grid: isDark ? '#263149' : '#d5def2',
      bars: isDark ? '#5b7bb8' : '#CADCF8',
    };
  }, [isDark]);

  ChartJS.defaults.color = chartTheme.muted;
  const options = useMemo(
    () => ({
      responsive: true,
      maintainAspectRatio: false,
      barThickness: 20,
      borderRadius: 2,
      animation: {
        duration: 0,
      },
      plugins: {
        legend: {
          display: false,
        },
      },
      scales: {
        x: {
          beginAtZero: true,
          grid: {
            display: false,
          },
          border: {
            display: false,
          },
        },
        y: {
          beginAtZero: true,
          grid: {
            color: chartTheme.grid,
            tickBorderDash: [2, 4],
          },
          border: {
            display: false,
            dash: [2, 4],
          },
        },
      },
    }),
    [chartTheme],
  );

  const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const periodData = period === '7days' ? data.week || [] : data.month || [];
  const labels = periodData.map((item) => weekDays[new Date(item.date).getDay()]);

  const chartData = {
    labels,
    datasets: [
      {
        label: 'Active members',
        data: periodData.map((item) => item.value),
        backgroundColor: chartTheme.bars,
      },
    ],
  };

  return (
    <div>
      <div className="mt-3 mb-3 flex min-h-11 flex-wrap items-center">
        <HeaderSwitchWrapper key="tabSwitcher">
          <SwitchButton active={period === '7days'} onClick={() => setPeriod('7days')}>
            Last 7 days
          </SwitchButton>
          <SwitchButton active={period === '30days'} onClick={() => setPeriod('30days')}>
            Last 30 days
          </SwitchButton>
        </HeaderSwitchWrapper>
      </div>
      <div className="h-[130px] pt-[30px]">
        <Bar options={options} data={chartData} />
      </div>
    </div>
  );
};
